const progressoGeracaoRelatorio = (progresso: number, total: number) => {
  return Math.round((progresso * 100) / total);
};

export { progressoGeracaoRelatorio };
